import React from "react";
import { Link } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";

export default function NotFound() {
  return (
    <>
      <Navbar />
      <main
        className="overflow-hidden d-flex align-items-center justify-content-center"
        style={{
          minHeight: "90vh",
          background: "linear-gradient(135deg, #fff 0%, #fcfcfc 100%)",
          padding: "100px 0",
          position: "relative",
        }}
      >
        <div className="container">
          <div className="row align-items-center">
            {/* Left side: Large 404 with floating product */}
            <div className="col-lg-6 text-center text-lg-start mb-50 mb-lg-0">
              <div
                className="position-relative d-inline-block wow animate__fadeInLeft"
                data-wow-delay=".2s"
              >
                <h1
                  style={{
                    fontSize: "clamp(180px, 25vw, 350px)",
                    fontWeight: "900",
                    color: "rgba(167, 34, 0, 0.04)",
                    lineHeight: "0.8",
                    margin: 0,
                  }}
                >
                  404
                </h1>
                <div
                  className="position-absolute top-50 start-50 translate-middle w-100 d-flex justify-content-center"
                  style={{
                    animation: "float_404 6s ease-in-out infinite",
                  }}
                >
                  <img
                    src="/assets/img/a1-img/dash__elements/plate4.png"
                    alt="Delicious Treat"
                    style={{
                      maxWidth: "320px",
                      filter: "drop-shadow(0 30px 60px rgba(167,34,0,0.25))",
                    }}
                  />
                </div>
              </div>
            </div>

            {/* Right side: Inspiring Content */}
            <div className="col-lg-6">
              <div
                className="ps-lg-5 text-center text-lg-start wow animate__fadeInRight"
                data-wow-delay=".4s"
              >
                <span
                  className="text-uppercase fw-bold mb-10 d-block"
                  style={{
                    color: "var(--clr-custom-2)",
                    fontSize: "14px",
                    letterSpacing: "3px",
                  }}
                >
                  The Secret Ingredient is Missing
                </span>
                <h2 className="display-4 fw-bold mb-20 text-dark">
                  Lost in the Aroma?
                </h2>
                <p
                  className="mb-40 text-muted"
                  style={{ fontSize: "19px", lineHeight: "1.8" }}
                >
                  Even the finest recipes have a missing page. This link may
                  have been whisked away, but the treats you love are still
                  waiting. Let's get you back to the goodness.
                </p>

                <div className="d-flex flex-column flex-sm-row gap-3 justify-content-center justify-content-lg-start">
                  <Link
                    to="/"
                    className="bm-hero__cta px-5 py-3 rounded-pill text-decoration-none shadow-lg text-white btn-glow"
                  >
                    Return Home
                  </Link>
                  <Link
                    to="/categories"
                    className="btn btn-outline-dark px-5 py-3 rounded-pill fw-bold text-decoration-none border-2"
                  >
                    Explore Shop
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Animated Background Elements */}
        <div className="error-particles">
          <div className="particle p1"></div>
          <div className="particle p2"></div>
          <div className="particle p3"></div>
        </div>

        <style>
          {`
            @keyframes float_404 {
              0%, 100% { transform: translate(-50%, -50%) translateY(0px) rotate(0deg); }
              50% { transform: translate(-50%, -50%) translateY(-30px) rotate(5deg); }
            }
            @keyframes glow {
              0%, 100% { box-shadow: 0 0 20px rgba(167, 34, 0, 0.3); }
              50% { box-shadow: 0 0 40px rgba(167, 34, 0, 0.6); }
            }
            @keyframes pulse_particle {
              0%, 100% { opacity: 0.2; transform: scale(1); }
              50% { opacity: 0.5; transform: scale(1.4); }
            }
            .display-4 { font-size: clamp(2.5rem, 5vw, 3.5rem); }
            .btn-glow { animation: glow 3s infinite ease-in-out; }
            .error-particles .particle {
              position: absolute;
              background: var(--clr-custom-2);
              border-radius: 50%;
              pointer-events: none;
              z-index: 0;
              animation: pulse_particle 5s infinite ease-in-out;
            }
            .p1 { width: 12px; height: 12px; top: 15%; left: 15%; animation-delay: 0s; }
            .p2 { width: 20px; height: 20px; bottom: 25%; left: 45%; animation-delay: 1.5s; }
            .p3 { width: 10px; height: 10px; top: 35%; right: 12%; animation-delay: 3s; }
          `}
        </style>
      </main>
      <Footer />
    </>
  );
}
